export default __webpack_public_path__ + "static/media/default_company_logo.3bd45218.jpg";